module.exports = __webpack_public_path__ + "static/media/animated_ashutosh.af5fd387.png";